import { FormGroup } from '@angular/forms';
import type { FormField } from '../../interfaces/form.interface';

/** Executes dropdown transform callbacks attached to a field definition. */
export class DropdownTransformExecutor<T> {
    constructor(private readonly model: FormGroup) {}

    public applyTransforms(field: FormField<T>): void {
        field.input?.dropdownConfiguration?.transform?.forEach(transform => transform(field, this.model));
    }
}
